import { InviteToApplyLandingPage } from 'features/Connect/features/ConnectATSIntegration/InviteToApply/InviteToApplyLandingPage';
import { Alert } from 'sharedComponents/Alert';
import auth from 'utils/auth';
import { PageContainer } from '../Navbar/styles';

export const PrincipalInviteToApply = () => {
  const user = auth.getUser();

  if (user) {
    return (
      <PageContainer>
        <InviteToApplyLandingPage />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Alert type="error">Unable to load. Please log in and try again.</Alert>
    </PageContainer>
  );
};
